import { render, staticRenderFns } from "./SsoStepUpController.vue?vue&type=template&id=8fe15102"
import script from "./SsoStepUpController.vue?vue&type=script&lang=ts"
export * from "./SsoStepUpController.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports